import { CoupleEatingDinner } from '@frontend/assets';
import { UPGRADE_HOUSEHOLD_CTA_COPY, useFeatureValue, useVisibilityController } from '@frontend/react';
import { Button, Card, Icon, Image, Text, XStack, YStack } from '@frontend/web-react';
import { PlanManagementModal } from '@frontend/web/components/DomainSpecific/Account/PlanManagement';

export const HouseholdUpgradeCTA = () => {
  const [isPlanModalOpen, { close: closePlanModal, open: openPlanModal }] = useVisibilityController();
  const { value } = useFeatureValue('upgrade_household_cta_copy', UPGRADE_HOUSEHOLD_CTA_COPY);
  const { benefits, button_label, heading, subheading } = value;
  return (
    <>
      <Card className="overflow-hidden rounded-lg border-borderTertiary bg-trueWhite p-none" noHoverEffect withBorder>
        <XStack className="items-stretch">
          <YStack className="max-w-lg flex-1 gap-md p-xl">
            <Text type="h3">{heading}</Text>
            <Text color="tertiary" type="p-md">
              {subheading}
            </Text>
            <YStack className="gap-sm">
              {benefits.map((benefit) => (
                <XStack className="items-center gap-sm" key={benefit}>
                  <Icon color="success" name="IconCheck" size="sm" />
                  <Text type="p-md">{benefit}</Text>
                </XStack>
              ))}
            </YStack>
            <XStack className="mt-sm">
              <Button label={button_label} onClick={openPlanModal} size="lg" variant="primary" />
            </XStack>
          </YStack>
          <YStack className="ml-auto hidden shrink-0 self-stretch overflow-hidden lg:flex lg:w-2/5">
            <Image className="size-full" fit="cover" source={CoupleEatingDinner} />
          </YStack>
        </XStack>
      </Card>
      <PlanManagementModal closeModal={closePlanModal} isOpen={isPlanModalOpen} />
    </>
  );
};
